module.exports = __webpack_public_path__ + "static/media/stationary4.a8c0ad7c.png";